import { type FlowRunEvent, isAsyncMessagingChannel } from '../types'
import { MessageBubble } from './message-bubble'
import { SystemEvent } from './system-event'

export const EventRenderer = ({
  event,
  nodeChannel,
  isLastChunk,
  firstEventTimestamp,
}: {
  event: FlowRunEvent
  nodeChannel: string | null
  isLastChunk: boolean
  firstEventTimestamp?: string
}) => {
  // const { channelName } = useFlowRunStore((state) => state.asyncAgentMeta)
  if (event.event_name === 'SYSTEM_CHUNK_CREATED') {
    return (
      <SystemEvent
        timestamp={event.timestamp}
        type={event.type}
        text={event.text}
        metadata={event.metadata}
        firstEventTimestamp={firstEventTimestamp}
        toolName={event.tool_name}
        toolInput={event.tool_input}
        toolResponse={event.tool_response}
        toolCallError={event.tool_call_error}
        time={event.time}
        channel={nodeChannel}
      />
    )
  }
  if (
    nodeChannel &&
    isAsyncMessagingChannel(nodeChannel) &&
    event.event_name === 'NODE_CHUNK_CREATED'
  ) {
    if (!event.text && !event.attributes) return null
    return (
      <MessageBubble
        isLastChunk={isLastChunk}
        attributes={event.attributes || undefined}
        text={event.text}
        sender={event.sender as 'user' | 'assistant' | 'agent'}
        timestamp={event.timestamp}
        channel={nodeChannel}
      />
    )
  }

  // This is a workaround to show the bot started speaking event in the correct place
  if (event.event_name === 'NODE_CHUNK_CREATED' && nodeChannel === 'call') {
    return (
      <div className="flex flex-col">
        <SystemEvent
          timestamp={event.timestamp}
          type={event.sender === 'assistant' ? 'AGENT_RESPONSE' : 'USER_RESPONSE'}
          text={event.text}
          firstEventTimestamp={firstEventTimestamp}
        />
        <div className="font-inter text-s-400 text-foreground ml-[118px] -mt-1 break-words [overflow-wrap:anywhere]">
          {event.text}
        </div>
      </div>
    )
  }

  if (event.event_name === 'NODE_CHUNK_CREATED' && event.sender && nodeChannel === 'call') {
    return (
      <div className="font-inter text-s-400 text-foreground ml-[118px] -mt-5 first:mt-0 break-words [overflow-wrap:anywhere]">
        {event.text}
      </div>
    )
  }
  return null
}
